import { uuidRegex } from 'app/constants'

export enum LoginMethodTypes {
  Local = 'local',
  SSO = 'sso',
}

export const isSystemUser = ({ username, name }: { username?: string; name: string }) => {
  const fieldToUse = username ?? name
  const isUuid = uuidRegex.test(fieldToUse)
  return isUuid || fieldToUse === 'kplane-clustmgr'
}

/**
 * Known internal OpenStack/Platform9 service accounts.
 * These use a bare service name instead of a real email address and must not appear in the user list.
 * Source: default service users created by OpenStack installer + Platform9-specific agents.
 * When adding new service accounts, update this list accordingly.
 */
const internalServiceUsers = [
  'notifications',
  'preference-store',
  'blackbox-exporter',
  'resmgr',
  'hagrid',
  'discovery',
  'vouch',
  'placement',
  'glance',
  'designate',
  'nova',
  'cinder',
  'neutron',
  'openstackexporter',
  'mors',
  'watcher',
  'octavia',
  'hamgr',
  'barbican',
  'pf9-ha-slave',
  'appcatalog',
]

/**
 * Returns true for real user accounts, false for internal service accounts.
 * Filters by matching email against the known internal service user list.
 */
export const filterValidUsers = (user: { email?: string | null }): boolean =>
  !internalServiceUsers.includes(user.email)
